import AssignmentForm from '@app/components/AssignmentForm'
import { actionCreators as assignmentFormActionCreators } from '@app/components/AssignmentForm/modules/assignmentForm'
import EditPageContainer from '@app/components/EditPageContainer'
import { ICurrentUserState } from '@app/store/modules/account'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'

interface IComponentRouterProps {
  id: string
}

type IComponentProps = ICurrentUserState &
  RouteComponentProps<IComponentRouterProps> &
  typeof assignmentFormActionCreators

export default class AssignmentEditPage extends React.Component<
  IComponentProps,
  {}
> {
  public assignmentId: string

  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public componentDidMount() {
    const { id } = this.props.match.params

    this.assignmentId = id
  }

  public render() {
    return (
      <EditPageContainer
        saveDisabled={false}
        title='New Assignment'
        onSaveClick={this._saveAssignment}
        onCancelClick={this._cancel}
      >
        <Card className='container mt-4'>
          <CardBody>
            <AssignmentForm id={this.props.match.params.id} />
          </CardBody>
        </Card>
      </EditPageContainer>
    )
  }

  private _saveAssignment() {
    this.props.saveAssignmentForm(this.assignmentId)

    if (!this.props.match.params.id) {
      this.props.history.push('/assignments')
    }
  }

  private _cancel() {
    this.props.history.goBack()
  }
}
